import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import { RFQSchema } from "../../../Schemas/purchase/rfq_schema";
import { RFQINFO, RFQINFOlineItemInfo } from "../../../SchemaInfo/info";
import { getId, toTitleCase } from "../../../Components/Functions/word.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const ADDRFQ = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [data, setData] = useState([]);
  const [rfqInfo, setRfqInfo] = useState(RFQINFO);
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryId = searchParams.get("duplicate");
    const today = new Date();

    if (queryId) {
      setLoading(true);
      performRequest("GET", `/rfq/getRFQById/${queryId}`)
        .then((res) => {
          if (res.status === 200) {
            let { rfqNumber, ...data } = res.data;
            setRfqInfo(data);
          } else {
            Toast("error", "Error while getting PO!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [location.search]);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.MaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);
  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  const handelSubmit = (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });

    values = {
      ...values,
      generatedBy: userData.Name,
      vendorQuotationOrderFor: toTitleCase(values.vendorQuotationOrderFor),
    };
    setLoading(true);
    performRequest("POST", "/rfq/createRFQ", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "RFQ created successfully!");

          navigate(`/rfq`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    performRequest("GET", "/poDcPi/getAllVendorList")
      .then((res) => setVendors(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const checkTouched = (obj) => {
    if (
      obj.deliveryDate === "" &&
      obj.gstRate === "" &&
      obj.itemPrice === "" &&
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.notes === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Purchase Management</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">New Request For Quotation</h2>
            </div>

            <Formik
              initialValues={rfqInfo}
              validationSchema={RFQSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor quotation for
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="vendorQuotationOrderFor"
                        />

                        {props.touched.vendorQuotationOrderFor &&
                          props.errors.vendorQuotationOrderFor && (
                            <p className="text-danger">
                              {props.errors.vendorQuotationOrderFor}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vendor quotation date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="date"
                          name="vendorQuotationOrderDate"
                        />

                        {props.touched.vendorQuotationOrderDate &&
                          props.errors.vendorQuotationOrderDate && (
                            <p className="text-danger">
                              {props.errors.vendorQuotationOrderDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Country of supply
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="countryOfSupply">
                          <option value="">Select Country</option>
                          <option value="india">India</option>
                        </CustomSelect>

                        {props.touched.countryOfSupply &&
                          props.errors.countryOfSupply && (
                            <p className="text-danger">
                              {props.errors.countryOfSupply}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Place of supply
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="placeOfSupply" />

                        {props.touched.placeOfSupply &&
                          props.errors.placeOfSupply && (
                            <p className="text-danger">
                              {props.errors.placeOfSupply}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Vendor
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="vendor">
                          <option value="">Select</option>
                          {vendors?.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.businessName}
                              </option>
                            );
                          })}
                        </CustomSelect>

                        {props.touched.vendor && props.errors.vendor && (
                          <p className="text-danger">{props.errors.vendor}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Project
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="project">
                          <option value="">Select</option>
                          {projects &&
                            projects?.map((pro) => {
                              return (
                                <option
                                  key={pro.cpNumber}
                                  value={getId(pro.cpNumber)}
                                >
                                  {pro.clientName}
                                </option>
                              );
                            })}
                        </CustomSelect>

                        {props.touched.project && props.errors.project && (
                          <p className="text-danger">{props.errors.project}</p>
                        )}
                      </div>
                    </div>

                    <hr />
                    <h3>Line Items :</h3>
                    <hr />
                    <FieldArray name="lineItems">
                      {({ push, remove }) => (
                        <div>
                          {props.values.lineItems.map((lineItem, index) => (
                            <div key={index}>
                              <div className="row g-3 align-items-center">
                                {props?.values?.lineItems?.[index]?.itemFrom !==
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">
                                      Particulars:
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                      />
                                    </div>
                                  </div>
                                )}
                                {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Particulars
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                        value={
                                          props?.values?.lineItems?.[index]?.id
                                        }
                                        onChange={(e) => {
                                          let item = data?.find(
                                            (el) => el.id == e.target.value
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].particulars`,
                                            item?.item
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].id`,
                                            item?.id
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].hsn`,
                                            item?.hsn
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemUnit`,
                                            item?.unit
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemPrice`,
                                            item?.cost
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {data?.map((el) => {
                                          return (
                                            <option key={el.id} value={el?.id}>
                                              {el?.item}
                                            </option>
                                          );
                                        })}
                                      </CustomSelect>
                                    </div>
                                  </div>
                                )}

                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item units
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name={`lineItems[${index}].itemUnit`}
                                    >
                                      <option value="">Select</option>
                                      <option value="nos">Nos</option>
                                      <option value="kg">Kg</option>
                                      <option value="grams">Grams</option>
                                      <option value="ltr">Litter</option>
                                      <option value="ml">ML</option>
                                      <option value="packs">Packs</option>
                                      <option value="pair">Pair</option>
                                      <option value="sqm">SqM</option>
                                      <option value="sqft">SqFt</option>
                                      <option value="mts">Meters</option>
                                      <option value="pcs">Pices</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Quantity
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].itemQuantity`}
                                    />
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Delivery date
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      name={`lineItems[${index}].deliveryDate`}
                                      type="date"
                                    ></CustomInput>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <button
                                    className="col-3 btn btn-primary"
                                    style={{
                                      width: "70px",
                                      height: "30px",
                                    }}
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                          <button
                            className="btn btn-primary mt-2 me-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...RFQINFOlineItemInfo,
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...RFQINFOlineItemInfo,
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Inventory Item
                          </button>
                          <button
                            className="btn btn-primary mt-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...RFQINFOlineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...RFQINFOlineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Custom Line Item
                          </button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create RFQ" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ADDRFQ;
